import React from 'react'
import Modal from './Modal'
import css from './Modal.module.scss'

export default function ModalAbout({isOpen,closeModal}) {
	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}>
				<div className={css.mail}>Спасибо, ваше обращение<br/>передано в редакцию</div>
		</Modal>
	)
}